export const selectCard = (state, number) => state.cards.filter(card => card.number === number)[0]